module.exports = __webpack_public_path__ + "static/media/logics-academy-shadow.db096a3e.png";